<template>
	<v-container fluid pa-0 dark flat my-5>
		<v-layout row wrap class="inner-container" justify-center mx-auto>
			<v-flex xs12 justify-center>
				<h1 class="mb-2">Detalles de tu pedido</h1>
				<v-divider></v-divider>
			</v-flex>
		</v-layout>
		<!-- <v-layout row wrap class="inner-container" justify-center mx-auto mt-5 > -->
		<v-layout row wrap class="inner-container" justify-center mx-auto mt-5 v-if="pedido.created">
			<v-flex xs12 sm12 md4 justify-center px-2>
				<p class="mb-0"><b>Usuario: </b> {{ pedido.usuario.nombre }} ({{ pedido.usuario.email }})</p>
				<p class="mb-0"><b>Tipo: </b> {{ pedido.tipo }}</p>
				<p class="mb-0"><b>Fecha de creación: </b> {{ pedido.created| dateFromTimestamp }}</p>
				<!-- Pendiente Fecha de servicio -->
					<!-- <p class="mb-1"><b>Fecha Servicio: </b> {{ pedido.fecha_servicio + ' ' + pedido.hora_servicio | formatDate }}</p> -->
				<!-- Fin fecha de servicio -->
				<p class="mb-0"><b>Estado: </b> Cotización </p>
				<!-- <p class="mb-1"><b>Tipo Servicio: </b> {{ pedido.tipo }}</p> -->
				<p class="mb-0"><b>Dirección Origen: </b><br/>{{ pedido.direcciones.origen }}</p>
				<p class="mb-0"><b>Dirección Destino: </b><br/>{{ pedido.direcciones.destino }}</p>
				<p class="mb-0"><b>Valor Servicio: </b> {{ pedido.valorBase | CLP }}</p>
				<div v-if="checkIfCharges(1)">
					<h4>Cargos</h4>
					<ul>
						<li v-for="(charge, index) in pedido.post_charge" class="mb-2">
							<p style="margin:0">Detalle: {{charge.glosa}}</p>
							<p style="margin:0">Monto: {{charge.monto}}</p>
						</li>
						<li v-for="(charge, index) in pedido.cargos" class="mb-2">
							<p style="margin:0">Detalle: {{charge.glosa}}</p>
							<p style="margin:0">Monto: {{charge.monto}}</p>
						</li>
					</ul>
				</div>
				<div v-if="checkIfCharges(2)">
					<h4>Descuentos</h4>
					<ul>
						<li v-for="(charge, index) in pedido.post_discount" class="mb-2">
							<p style="margin:0">Detalle: {{charge.glosa}}</p>
							<p style="margin:0">Monto: {{charge.monto}}</p>
						</li>
						<li v-for="(charge, index) in pedido.descuentos" class="mb-2">
							<p style="margin:0">Detalle: {{charge.glosa}}</p>
							<p style="margin:0">Monto: {{charge.monto}}</p>
						</li>
					</ul>
				</div>
        <div v-if="checkIfCharges(3)">
          <hr class="my-2">
					<v-layout row wrap justify-start>
					<p class="mb-1"><b>Valor Final Servicio: </b> {{ valorFinalCD | CLP }}</p>
					<v-tooltip right max-width="300px">
						<template slot="activator">
							<v-layout align-center>
								<img
									:src='require("../../assets/static/img/info.png")'
									class="ml-2"
									width="16px"
									height="16px"
									contain
								/>
							</v-layout>
						</template>
		        <span>Este valor incluye los cargos y descuentos aplicados al servicio.</span>
			    </v-tooltip>
				  </v-layout>
        </div>
		<p v-if="pedido.pedidoConvenio" ><b>Fecha Facturacion: </b>{{ fechaFacturacion }} de cada mes.</p>
		<p class="mb-0"><b>Condiciones: </b> {{ pedido.condiciones }}</p>
		<p v-if="tipoCliente === 'Empresa' || tipoCliente === 'Convenio'" class="mb-0"><b>Linea de Credito: </b>{{ lineaCredito.usado | CLP}} / {{ lineaCredito.montoMaximo | CLP}} </p>
		
		<div v-if="pedido.docCliente">
			<br>
			<p>Documentos Cliente: </p>
			<div v-for="(documento, index) in pedido.docCliente" :key="index">
				<v-btn  color="primary" @click="viewDoc(documento)">Ver Documento {{ index + 1}} </v-btn>
			</div>
		</div>
		<div v-if="pedido.servicePhotos">
			<br>
			<p>Documentos de servicio: </p>
			<div v-for="(documento, index) in pedido.docCliente" :key="index">
				<p>Documento: {{ documento.nombre }}</p><v-btn flat color="primary" @click="viewDoc(documento.url)">Ver Archivo</v-btn>
			</div>
		</div>
		<div v-if="pedido.facturaPrepago && pedido.facturaPrepago">
			<br>
			<p>Factura DUO: </p><v-btn color="primary" @click="viewDoc(pedido.facturaPrepago.factura)">Ver Factura</v-btn>
		</div>
				<!-- Hasta aqui bien. -->
			 	<!-- <div v-if="pedido.cargos && pedido.cargos.length > 0">
					<hr class="my-2">
					<h5 class="mt-0">Cargos adicionales</h5>
					<div v-for="(cargo, index) in pedido.cargos" :key="index">
						<p style="font-size:13px;">{{index + 1}}.- Monto: {{cargo.monto | CLP}} | Glosa: {{cargo.glosa}}</p>
					</div>
				</div>
        <div v-if="pedido.descuentos && pedido.descuentos.length > 0">
          <hr class="my-2">
          <h5 class="mt-0">Descuentos</h5>
          <div v-for="(descuento, index) in pedido.descuentos" :key="index">
            <p style="font-size:13px;">{{index + 1}}.- Monto: {{descuento.monto | CLP}} | Glosa: {{descuento.glosa}}</p>
          </div>
        </div>
        <div v-if="(pedido.cargos && pedido.cargos.length > 0) || (pedido.descuentos && pedido.descuentos.length > 0)">
          <hr class="my-2">
					<v-layout row wrap justify-start>
					<p class="mb-1"><b>Valor Final Servicio: </b> {{ valorFinalCD | CLP }}</p>
					<v-tooltip right max-width="300px">
						<template slot="activator">
							<v-layout align-center>
								<img
									:src='require("../../assets/static/img/info.png")'
									class="ml-2"
									width="16px"
									height="16px"
									contain
								/>
							</v-layout>
						</template>
				<span>Este valor incluye los cargos y descuentos aplicados al servicio.</span>
				</v-tooltip>
			</v-layout>
        </div> -->
			</v-flex>
			
				<v-flex xs12 sm12 md4 justify-center px-2>
				<v-toolbar color="#1f97b9" dark v-in-viewport class="item-qty-container">
					<img :src='require("../../assets/static/img/clipboard.png")' style="width: 30px;">
					<v-toolbar-title class="texto-listado-articulos-sel no-float">Elementos a transportar</v-toolbar-title>
				</v-toolbar>
				<v-card>
					<v-card-text class="grey lighten-3" style="color: black">
						<v-list class="grey lighten-3 listado-elementos" style="color: black;" dense>
							<p>{{ pedido.mensaje }}</p>
						</v-list>
					</v-card-text>
				</v-card>
			</v-flex>
			
			<v-flex xs12 sm12 md4 justify-center px-2>
				<v-toolbar color="#1f97b9" dark v-in-viewport class="item-qty-container">
					<img :src='require("../../assets/static/img/fecha.png")' style="width: 30px;">
					<v-toolbar-title class="texto-listado-articulos-sel no-float">Fecha y hora del servicio</v-toolbar-title>
				</v-toolbar>
				
				<v-card>
					<div>
					<v-menu
						ref="menuDate"
						:close-on-content-click="true"
						v-model="menu"
						:nudge-right="40"
						lazy
						transition="scale-transition"
						offset-y
						full-width
						min-width="290px"
						class="mb-5"
						padding-left="100px"
						:disabled="!primerPago"
					>
						<v-text-field
							slot="activator"
							v-model="fecha"
							label="Seleccione Fecha"
							color="#1f97b9"
							readonly
							:rules="rules.nameRules"
							:disabled="!primerPago"
						>
							<img :src='require("../../assets/static/img/fecha.png")' style="width: 25px;height:25px;" slot="prepend">
						</v-text-field>
						<v-date-picker
							v-model="fecha"
							:min="today"
							no-title
							scrollable
							prev-icon="fas fa-chevron-left caption"
							next-icon="fas fa-chevron-right caption"
							locale="es-mx"
							first-day-of-week="1"
						>
							<v-spacer></v-spacer>
							<v-btn flat color="primary" @click="menu = false">Cancelar</v-btn>
						</v-date-picker>
					</v-menu>

					<div class="v-input__prepend-outer">
						<img :src='require("../../assets/static/img/hora.png")' style="width: 25px;height:25px;">
					</div>
					<div class="hour-picker-container">
						<v-select
							v-model="hora"
							:items="horas"
							:rules="rules.nameRules"
							append-icon="fas fa-caret-down"
							label="Seleccione Hora"
							:disabled="!primerPago"
						></v-select>
					</div>
					</div>
				</v-card>
				
		<!-- <v-card tile class="pago-dialog mt-3" v-if="monto_pagado <= Math.round(valorFinal * 0.95)"> -->
		<div v-if="monto_pagado <= Math.round(valorFinal * 0.95) && !pedido.pedidoConvenio">
			
          <v-toolbar card dark color="#1f97b9">
            <v-toolbar-title>Realizar Pago</v-toolbar-title>
          </v-toolbar>
          <v-card-text v-if="typePay !== 0">
          	<v-form ref="formPago">
	          	<v-layout row wrap align-center>	          
	          		<v-flex sm12 md12 xs12 px-0>
			            <v-list three-line subheader>
			              <v-list-tile avatar class="payment-selector" :class="{ 'selected-payment': selectedPayment == 1 }" @click="selectPayment(1)">
			                <v-list-tile-content>
			                  <v-list-tile-title style="height: 100px;">
								<v-layout v-if="primerPago" row wrap justify-space-between align-center>
										<v-flex md7 sm7 xs12>Pago anticipado tiene <b>5% de Descuento</b></v-flex>
										<v-flex md5 sm5 xs12 text-xs-right><br>
										<span class="title precio-container-payment precio-total-payment"><del>{{paymentValue | CLP}}</del></span> <br>
										<span  class="subheading precio-container-payment precio-discount-payment"> {{paymentValue * 0.95 | CLP}}</span>
										</v-flex>
			                  	</v-layout>
								<v-layout v-else row wrap align-center>
										<v-flex md7 sm7 xs12>Pagar saldo pendiente: </v-flex>
										<v-flex md5 sm5 xs12 text-xs-right><br><br>
										<span class="title precio-container-payment precio-total-payment">{{paymentValue | CLP}}</span>
										<span  class="subheading precio-container-payment precio-discount-payment">    </span>
										</v-flex>
			                  	</v-layout>
			                  </v-list-tile-title>
			                </v-list-tile-content>
			              </v-list-tile>
			            	<v-divider></v-divider>
			              <v-list-tile avatar class="payment-selector" :class="{ 'selected-payment': selectedPayment == 3 }" @click="selectPayment(3)" v-if="typePay === 1">
			                <v-list-tile-content>
			                  <v-list-tile-title style="height:auto;">
							    <v-layout row wrap justify-space-between align-center>
									<v-flex md7 sm7 xs12>Abono (mínimo 50%: {{paymentValue * 0.5 | CLP}})</v-flex>
									<v-flex md5 sm5 xs12 text-xs-right>
										<v-text-field
											v-model="toPayValue"
											placeholder="Monto a pagar"
											type="number"
											style="max-width: 200px;"
											class="input-qty-second"
											color="#1f97b9"
											:max="paymentValue * 0.95"
											:min="paymentValue * 0.5"
											:messages="abonoMessage"
											persistent-hint
											@input="changeAbono"
										></v-text-field>
			                  		</v-flex>
			                  	</v-layout>
			                  </v-list-tile-title>
			                </v-list-tile-content>
			              </v-list-tile>
			            </v-list>
			          </v-flex>
		          </v-layout>
		        </v-form>
	          <v-divider class="my-3"></v-divider>
			  	<v-layout row wrap justify-space-between align-center :disabled="primerPago">
						<span class="title precio-container-payment precio-total-payment">Documento Tributario</span> <br>
						<span class="precio-container-payment precio-total-payment" >
							<!-- <input type="Radio" name="documentoTributario" value="Boleta" v-on:click="tributario('Boleta')"> Boleta
							<input type="Radio" name="documentoTributario" value="Factura" v-on:click="tributario('Factura')"> Factura -->
							<input type="radio" id="Boleta" value="Uno" v-model="documentoTributario" :disabled="!primerPago">
							<label for="uno">Boleta   </label>
							<input type="radio" id="Factura" value="Factura" v-model="documentoTributario" :disabled="!primerPago">
							<label for="Dos">Factura</label>
						</span>
						
				</v-layout>
			  <v-divider class="my-3"></v-divider>
			  <div v-if="documentoTributario == 'Factura'">
					<p><h3> Datos Facturación</h3></p>
					<v-text-field
						v-model="factura.rut"
						label="R.U.T"
						:rules="rules.nameRules"
						required
						:disabled="!primerPago"
					></v-text-field>
					<v-text-field
						v-model="factura.razonSocial"
						label="Razón Social"
						:rules="rules.nameRules"
						required
						:disabled="!primerPago"
					></v-text-field>
					<v-text-field
						v-model="factura.giroComercial"
						label="Giro Comercial"
						:rules="rules.nameRules"
						required
						:disabled="!primerPago"
					></v-text-field>
					<v-text-field
						v-model="factura.direccion"
						label="Dirección"
						:rules="rules.nameRules"
						required
						:disabled="!primerPago"
					></v-text-field>
					<v-text-field
						v-model="factura.comuna"
						label="Comuna"
						:rules="rules.nameRules"
						required
						:disabled="!primerPago"
					></v-text-field>
					<v-text-field
						v-model="factura.ciudad"
						label="Ciudad"
						:rules="rules.nameRules"
						required
						:disabled="!primerPago"
					></v-text-field>
					<v-text-field
						v-model="factura.telefono"
						label="Teléfono"
						:rules="rules.nameRules"
						required
						:disabled="!primerPago"
					></v-text-field>

					<v-divider class="my-3"></v-divider>	
				</div>
				<div v-if="documentoTributario == 'Boleta'">
					<v-text-field
						v-model="boleta.rut"
						label="R.U.T"
						:rules="rules.nameRules"
						required
						:disabled="!primerPago"
					></v-text-field>
					<v-text-field
						v-model="boleta.nombre"
						label="Nombre"
						:rules="rules.nameRules"
						required
						:disabled="!primerPago"
					></v-text-field>
				</div>
				<div v-else />
				
			<v-checkbox
					on-icon="far fa-check-square"
					off-icon="far fa-square"
					label=""
					color="black"
					hint="Leer términos y condiciones"
					v-model="terminos"
					class="terminos-check"
					hide-details
					persistent-hint
				>
					<p style="margin-bottom:0" slot="append" >Acepto los 
						<router-link style="color:black" :to="{ name: 'terminos'}" target="_blank">
							Términos y Condiciones
						</router-link>
					</p>
				</v-checkbox>
			  <v-divider class="my-3"></v-divider>
          		<v-layout v-if="terminos" row wrap justify-center align-center>
					<v-flex sm12 md6 xs12 class="text-xs-center">
									<v-img :src='require("../../assets/static/img/webpay-1.png")' max-height="70" contain></v-img>
					</v-flex>
					<!-- <v-flex sm12 md6 xs12 class="text-xs-center">
						<p>Tu pago será procesado de forma segura mediante <b>WebPay Plus</b></p>
					</v-flex> -->
					<!-- <v-flex sm12 md12 xs12 justify-center align-center  class="text-xs-center"> -->
					<v-flex sm12 md6 xs12 class="text-xs-center">
						<v-btn color="#1f97b9" outline large class="third-step-button mt-3" :disabled="toPayValue < paymentValue * 0.5 || toPayValue == 0 || idPedido == '' || loadingPay || documentoTributario == '' "  @click="goToPay(toPayValue, idPedido, 1)">
							<v-layout row wrap pa-1 justify-center align-center>
								<span v-if="!loadingPay"><p>Pagar con</p><p>tarjetas</p></span>
								<v-progress-circular
									v-if="loadingPay"
									:size="21"
									:width="3"
								indeterminate
								color="#1f97b9"
								class="mr-2"
							></v-progress-circular> <span v-if="loadingPay">Espera un segundo</span>
							</v-layout>
						</v-btn>
					</v-flex>

					<v-flex sm12 md6 xs12 class="text-xs-center">
									<v-img :src='require("../../assets/static/img/Logo-khipu-oficial.png")' max-height="70" contain></v-img>
					</v-flex>
					<!-- <v-flex sm12 md6 xs12 class="text-xs-center">
						<p>Tu pago será procesado de forma segura mediante <b>Khipu</b></p>
					</v-flex> -->
					<!-- <v-flex sm12 md12 xs12 justify-center align-center  class="text-xs-center"> -->
					<v-flex sm12 md6 xs12 class="text-xs-center">
						<v-btn color="#1f97b9" outline large class="third-step-button mt-3" :disabled="toPayValue < paymentValue * 0.5 || toPayValue == 0 || idPedido == '' || loadingPay || documentoTributario == '' "  @click="goToPay(toPayValue, idPedido, 22)">
							<v-layout row wrap pa-1 justify-center align-center>
								<span v-if="!loadingPay"><p>Pagar con</p><p>transferencia</p></span>
								<v-progress-circular
									v-if="loadingPay"
									:size="21"
									:width="3"
								indeterminate
								color="#1f97b9"
								class="mr-2"
							></v-progress-circular> <span v-if="loadingPay">Espera un segundo</span>
							</v-layout>
						</v-btn>
						<v-btn v-if="tipoCliente === 'Empresa' || tipoCliente === 'Convenio'" color="#1f97b9" outline large class="third-step-button mt-3" :disabled="toPayValue < paymentValue * 0.5 || toPayValue == 0 || idPedido == '' || loadingPay || cargadoCuentaCorriente" @click="cargoLineaCredito">Usar Linea de Credito DuoApp</v-btn>
					</v-flex>
				</v-layout>
          		</v-card-text>
				<v-card-text v-else>
					El pedido está pagado completamente
				</v-card-text>

          		<div style="flex: 1 1 auto;"></div>
        		<!-- </v-card> -->
				</div>
			</v-flex>			
		</v-layout>
		<v-dialog
		  v-model="dialogPagoCompleto"
		  max-width="600"
		>
		  <v-card>
        <v-toolbar card dark color="#1f97b9">
          <v-toolbar-title>Solicitud ingresada</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn class="btn-close-pago-dialog" dark icon @click="dialogPagoCompleto = false">
            <v-img :src='require("../../assets/static/img/cerrar.png")' max-height="25" contain></v-img>
          </v-btn>
        </v-toolbar>
		    <v-card-text>

        	<v-layout row wrap justify-center align-center>
        		<v-flex sm4 md4 xs12 class="text-xs-center" :class="{'px-0': $vuetify.breakpoint.smAndDown, 'pr-3': $vuetify.breakpoint.mdAndUp}">
							<v-img :src='require("../../assets/static/img/archive.png")' max-height="70" contain></v-img>
        		</v-flex>
        		<v-flex sm8 md8 xs12 :class="{'px-0': $vuetify.breakpoint.smAndDown, 'pl-3': $vuetify.breakpoint.mdAndUp}">
							<h3>Hemos recibido correctamente el pago.</h3>
							<h4 class="mb-3">Procesaremos tu solicitud a la brevedad</h4>
							<p class="ma-0">Los datos de tu pago son:</p>
							<!-- <p class="ma-0"><b>Código solicitud:</b> {{paymentInfo.id}}</p> -->
							<p class="ma-0"><b>Número Servicio:</b> {{paymentInfo.ns}}</p>
							<p class="ma-0"><b>Monto Pagado:</b> {{paymentInfo.monto | CLP}}</p>
							<p class="ma-0"><b>Fecha de Pago:</b> {{paymentInfo.fecha}}</p>
							<p class="ma-0"><b>Forma de Pago:</b> {{paymentInfo.forma_pago}}</p>
        		</v-flex>
      		</v-layout>		    	

		    </v-card-text>

		    <v-card-actions>
        	<v-layout row wrap justify-center align-center>
        		<v-flex sm12 md12 xs12 justify-center align-center class="text-xs-center">
							<v-btn color="#1f97b9" outline large class="third-step-button mt-3 py-3" @click="dialogPagoCompleto = false">
								Genial!
							</v-btn>
						</v-flex>
					</v-layout>
		    </v-card-actions>
		  </v-card>
		</v-dialog>
		<v-snackbar
			v-model="messageCuentaCorriente.show"
			:color="messageCuentaCorriente.type"
			right
			:timeout="4000"
			top>
			{{ messageCuentaCorriente.text }}
			<v-btn
				color="white"
				flat
				@click="messageCuentaCorriente.show = false">
				Ok
			</v-btn>
		</v-snackbar>
	</v-container>
</template>
<script>
	import { EventBus } from '../../events.js'
	import * as firebase from 'firebase/app'
	import 'firebase/firestore'
	import cryptoJS from 'crypto-js'
	import axios from 'axios'
	
  export default {
  	name: 'Solicitud',
	  filters: {
	    dateFromTimestamp: function(timestamp) {
	      let formattedDate = ''
	      if (timestamp.seconds) {
	        formattedDate = timestamp.toDate().toLocaleString()
	      } else {
	        formattedDate = new Date(timestamp).toLocaleString()
	      }
	      return formattedDate
	    },
	    FormaPago: function(forma) {
	    	if(forma === 'Flow.cl') {
	    		return 'WebPay Plus (Flow.cl)'
	    	}
	    	return forma
	    }
	  },
    data () {
      return {
		idCliente: '',
		cargadoCuentaCorriente: false,
		messageCuentaCorriente: {
			show: false,
			type: '',
			text: ''
		},
		lineaCredito: {
			montoMaximo: 0,
			usado: 0
		},
		tipoCliente: '',
		boleta: {
			nombre:'',
			rut: ''
		},
		factura: {
			rut:'',
			razonSocial: '',
			giroComercial: '',
			direccion: '',
			comuna: '',
			ciudad: '',
			telefono: ''
		},
		menu: '',
		documentoTributario: '',
		rules: {
			nameRules: [
				v => !!v || 'Campo obligatorio'
			]
		},
		horas: ['00:00','00:15','00:30','00:45','01:00','01:15','01:30','01:45','02:00','02:15','02:30','02:45','03:00','03:15','03:30','03:45','04:00','04:15','04:30','04:45','05:00','05:15','05:30','05:45','06:00','06:15','06:30','06:45','07:00','07:15','07:30','07:45','08:00','08:15','08:30','08:45','09:00','09:15','09:30','09:45','10:00','10:15','10:30','10:45','11:00','11:15','11:30','11:45','12:00','12:15','12:30','12:45','13:00','13:15','13:30','13:45','14:00','14:15','14:30','14:45','15:00','15:15','15:30','15:45','16:00','16:15','16:30','16:45','17:00','17:15','17:30','17:45','18:00','18:15','18:30','18:45','19:00','19:15','19:30','19:45','20:00','20:15','20:30','20:45','21:00','21:15','21:30','21:45','22:00','22:15','22:30','22:45','23:00','23:15','23:30','23:45'],
		today: new Date().toISOString().substr(0, 10),
		terminos: false,
        mantenedores: {},
        idPedido: '',
        pedido: {},
        headers: [
          {
            text: 'Forma',
            sortable: false
          },
          {
            text: 'Monto',
            sortable: false
          },
          {
            text: 'Fecha',
            sortable: false
          }
        ],
		abonoMessage: '',
		dialogPago: true,
		loadingPay: false,
		toPayValue: 0,
		paymentInfo: {
			id: '',
			monto: 0,
			fecha: '',
			forma_pago: ''
		},
		colorTooltipActivator: '#1f97b9',
		paymentValue: 0,
		selectedPayment: 1,
		valorFinal: 0,
		monto_pagado: 0,
		valorFinalCD: 0,
		dialogPagoCompleto: false,
		typePay: 0,
		montoDisponible: 0,
		primerPago: true,
		fechaFacturacion: '',
		fecha: '',
		hora: ''
      }
    },
    methods:{
		viewDoc(url) {
			var win = window.open(url, '_blank')
			// Cambiar el foco al nuevo tab (punto opcional)
			win.focus()
		},
    	checkIfCharges(type = 1){
    		if(type === 1){
    			return ( this.pedido.cargos && this.pedido.cargos.length ) > 0 || ( this.pedido.post_charge && this.pedido.post_charge.length > 0 )
    		}
    		if(type === 2){
    			return ( this.pedido.descuentos && this.pedido.descuentos.length ) > 0 || ( this.pedido.post_discount && this.pedido.post_discount.length > 0 )
    		}
    		return ( this.pedido.cargos && this.pedido.cargos.length ) > 0 || ( this.pedido.post_charge && this.pedido.post_charge.length > 0 ) || ( this.pedido.descuentos && this.pedido.descuentos.length ) > 0 || ( this.pedido.post_discount && this.pedido.post_discount.length > 0 )
    	},
			descuentaLineaCredito() {
				const db = firebase.firestore()
				this.cargadoCuentaCorriente = true
				const saldoUsado = this.lineaCredito.usado + this.pedido.valorBase
				const data = {
					cuentaCorriente: {
						montoMaximo: this.lineaCredito.montoMaximo,
						usado: saldoUsado
					}
				}
				const dataFleteCTE = {
					cargadoCuentaCorriente: true
				}
				const idCliente = this.$route.query.uid
				db.collection('users').doc(idCliente).update(data)
				db.collection('fletes_dev').doc(this.$route.params.id).update(dataFleteCTE)
			},
			cargoLineaCredito() {
				this.montoDisponible = this.lineaCredito.montoMaximo - this.lineaCredito.usado
				if (this.pedido.valorBase <= this.montoDisponible) {
					const data = this.pedido
					const cargoLC = firebase.functions().httpsCallable('cargoCuentaCorriente')
					cargoLC(data)
						.then(({ data }) => {
							console.log('Transaccion', data)
							this.descuentaLineaCredito()
							this.messageCuentaCorriente.show = true
							this.messageCuentaCorriente.type = 'success'
							this.messageCuentaCorriente.text = 'Operacion realizada, servicio agendado.'
						})
						.catch(httpsError => {
							console.log('error: ', httpsError)
							this.messageCuentaCorriente.show = true
							this.messageCuentaCorriente.type = 'success'
							this.messageCuentaCorriente.text = 'Su servicio fue agendado.'
						})
					console.log(data)
				} else {
					this.messageCuentaCorriente.show = true
					this.messageCuentaCorriente.type = 'error'
					this.messageCuentaCorriente.text = 'Tu saldo es insuficiente para esta operacion.'
				}
			},
			tributario(documento){
				this.documentoTributario = documento
			},
    	checkPayments(){
    		const percent = Math.round((this.monto_pagado / this.valorFinal)*100)/100
    		if(percent >= 0.95){
    			this.typePay = 0 //Pagado
    		}
    		else if(percent === 0){
    			this.typePay = 1 //Sin pago
    		}
    		else{
    			this.typePay = 2 //Pago Parcial
    		}
    	},
			get_pedido(idPedido){
				// console.log("gt: ", idPedido)
				let db = firebase.firestore()
				let self = this
				db.collection("fletes_dev").doc(idPedido).get().then(function(doc) {
						if (doc.exists) {
								self.pedido = doc.data()
								// console.log(self.pedido)
								self.monto_pagado = 0
								self.pedido.datoPagos.forEach((item) => {
									self.monto_pagado += parseInt(item.monto)
								})
								if (self.pedido.datoPagos.length >= 1) {
									console.log('El pedido Tiene pagos')
									self.primerPago = false
								}
								self.hora = self.pedido.hora
								self.fecha = self.pedido.fecha
								self.paymentValue = self.pedido.valorBase
								self.valorFinal = self.pedido.valorBase
								self.valorFinalCD = self.valorFinal
								self.paymentValue -= self.monto_pagado
								// console.log(self)
								if (self.pedido.cargadoCuentaCorriente) {
									self.cargadoCuentaCorriente = self.pedido.cargadoCuentaCorriente
								} else {
									self.cargadoCuentaCorriente = false
								}
								if(self.pedido.cargos && self.pedido.cargos.length > 0){
									self.pedido.cargos.forEach((item) => {
										self.paymentValue += item.monto
										self.valorFinalCD += item.monto
									})
								}
								if(self.pedido.descuentos && self.pedido.descuentos.length > 0){
									self.pedido.descuentos.forEach((item) => {
										self.paymentValue -= item.monto
										self.valorFinalCD -= item.monto
									})
								}
								if(self.pedido.post_charge && self.pedido.post_charge.length > 0){
									self.pedido.post_charge.forEach((item) => {
										self.paymentValue += item.monto
										self.valorFinalCD += item.monto
									})
								}
								if(self.pedido.post_discount && self.pedido.post_discount.length > 0){
									self.pedido.post_discount.forEach((item) => {
										self.paymentValue -= item.monto
										self.valorFinalCD -= item.monto
									})
								}
								if(self.pedido.oferta && self.pedido.oferta.activo){
									self.paymentValue -= self.pedido.oferta.monto
									self.valorFinal -= self.pedido.oferta.monto
								}
								if (self.pedido.documento_tributario) {
									if (self.pedido.documento_tributario.documento === 'Boleta') {
										self.documentoTributario = 'Boleta'
										self.boleta = self.pedido.documento_tributario.boleta	
										self.factura = self.pedido.documento_tributario.factura							
									} else if (self.pedido.documento_tributario.documento === 'Factura') {
										self.documentoTributario = 'Factura'
										self.factura = self.pedido.documento_tributario.factura
										self.boleta = self.pedido.documento_tributario.boleta
									}
								}
								self.selectPayment(1)
								self.checkPayments()
						} else {
								// doc.data() will be undefined in this case
								console.log("No such document!");
						}
				}).catch(function(error) {
						console.log("Error getting document:", error);
				});

			},
			changeAbono(){
				if(this.toPayValue > this.paymentValue){
					this.toPayValue = this.paymentValue
				} 
				this.abonoMessage = 'Saldo por pagar $' + Math.ceil(this.paymentValue - this.toPayValue).toLocaleString()
			},
			selectPayment(type){
				this.selectedPayment = type
				if(type === 1){ this.toPayValue = Math.ceil(this.paymentValue * 0.95) }
				else if(type === 2){ this.toPayValue = Math.ceil(this.paymentValue * 0.5) }
			},
			async goToPay(valor, idPedido, paymentMethod){
				console.log(valor)
				const here = this
				const pedido = this.pedido

				const db = firebase.firestore()
				if (here.documentoTributario == 'Factura') {
					const documento_tributario = {
							documento_tributario: {
								documento: here.documentoTributario,
								factura: here.factura
							}
							
						}
						await db.collection('fletes_dev').doc(idPedido).update(documento_tributario)
				} else if (here.documentoTributario == 'Boleta') {
					const documento_tributario = {
							documento_tributario: {
								documento: here.documentoTributario,
								boleta: here.boleta
							}
						}
					await db.collection('fletes_dev').doc(idPedido).update(documento_tributario)
				}
				if (here.typePay === 2) {
					valor = this.paymentValue
					console.log(valor)
				}
				if (here.fecha !== '' && here.hora !== '') {
					const data = {
						fecha: here.fecha,
						hora: here.hora,
						fecha_servicio_obj: new Date(here.fecha + 'T' + here.hora)
					}
					await db.collection('fletes_dev').doc(idPedido).update(data)
				}
				if(this.$refs.formPago.validate()){
					this.colorTooltipActivator = '#1f97b9'
					this.loadingPay = true
					let db = firebase.firestore()
					db.collection("pagos").add({
						id_pedido: idPedido,
						monto: valor,
						estado: 'Esperando Pago',
						fecha_ingreso: firebase.firestore.FieldValue.serverTimestamp()
					})
						.then(function(docRef) {
								here.payFlow(valor, docRef.id, idPedido, paymentMethod)
						})
					  .catch(error => {
					  	console.log(error)
							here.loadingPay = false
					  })
					
				}
			},
			payFlow(valor, idPago, idPedido, paymentMethod){

				const here = this
		    firebase.firestore().collection('system_info').doc('pagos').update({
		        qty_pagos: firebase.firestore.FieldValue.increment(1)
		    })
				let flow_params = {
					amount: valor,
					apiKey: '58D1DFFC-908B-43E9-80D0-1LA6424AC4FD',
					commerceOrder: idPago,
					email: this.pedido.usuario.email,
					optional: JSON.stringify({'idPedido': idPedido, 'tipo': 2}),
					paymentMethod: paymentMethod,
					subject: 'Pago Transportes DUO: ' + idPedido,
					urlConfirmation: 'https://us-central1-duoapp-56ef2.cloudfunctions.net/verificarFlow',
					urlReturn: 'https://us-central1-duoapp-56ef2.cloudfunctions.net/finalFlow'
				}
				let data = ''
				let signData = ''
				let cont = 0
				Object.keys(flow_params).forEach(function(key) {
					signData += '&' + key + '=' + flow_params[key]
				  data += '&' + encodeURIComponent(key) + '=' + encodeURIComponent(flow_params[key])
				  cont++
				  if(cont === 9){
						signData = signData.substring(1)
						data = data.substring(1)
				  	here.signAndSend(signData)
				  }
				});

			},
			signAndSend(signData){
				const here = this
				const signature = cryptoJS.HmacSHA256(signData, '83558e934b88eeab5293faa6cf9a4d19aae1b937')
				const payFlow = firebase.functions().httpsCallable('initFlow')
				axios({
						method: 'post',
						url: 'https://cors-anywhere.herokuapp.com/https://www.flow.cl/api/payment/create',
						headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
			  		data: signData + '&s=' + signature
					})
				  .then(response => {
				    window.location.href = response.data.url + "?token=" + response.data.token
				  })
				  .catch(error => {
				    console.log("Error Flow: ", error)
						here.loadingPay = false
				  })

			},
			async getUser(id) {
				console.log('entra')
				const db = firebase.firestore()
				const here = this
				await db.collection('users').doc(id).get().then(function(doc) {
					if (doc.exists) {
						const cliente = doc.data()
						here.fechaFacturacion = cliente.fechaFacturacion
						here.tipoCliente = cliente.tipoCliente
						here.boleta.nombre = cliente.nombre
						here.boleta.rut = cliente.rut
						here.factura.rut = cliente.rut
						here.factura.razonSocial = cliente.razonSocial
						here.factura.giroComercial = cliente.giroComercial
						here.factura.direccion = cliente.direccion
						here.factura.comuna = cliente.comuna
						here.factura.ciudad = cliente.ciudad
						here.factura.telefono = cliente.telefono
						here.lineaCredito.montoMaximo = cliente.cuentaCorriente.montoMaximo
						here.lineaCredito.usado = cliente.cuentaCorriente.usado
					} else {
						console.log('Cliente no existe')
					}
				})
			}
    },
    async mounted(){
		if (this.$route.query.uid) {
			this.idCliente = this.$route.query.uid
		}
		if (this.idCliente != '') {
			await this.getUser(this.idCliente)
		}
    	this.idPedido = this.$route.params.id
    	if(this.idPedido !== 'tk'){this.get_pedido(this.idPedido)}
    	else{
				const here = this
				if(this.$route.params.token){
					const signData = 'apiKey=58D1DFFC-908B-43E9-80D0-1LA6424AC4FD' + '&token=' + this.$route.params.token
					const signature = cryptoJS.HmacSHA256(signData, '83558e934b88eeab5293faa6cf9a4d19aae1b937')
			    this.$router.replace({name: 'solicitud'})

					axios({
							method: 'get',
							url: 'https://cors-anywhere.herokuapp.com/https://www.flow.cl/api/payment/getStatus?' + signData + '&s=' + signature,
							headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
						})
					  .then(async response => {
					  	here.idPedido = response.data.optional.idPedido
					  	here.get_pedido(response.data.optional.idPedido)
					  	if(response.data.status === 2){
								here.dialogPagoCompleto = true
								here.paymentInfo = {
									id: response.data.optional.idPedido,
									monto: response.data.amount,
									fecha: response.data.paymentData.date,
									forma_pago: response.data.paymentData.media
								}
								await db.collection('pedidos').doc(response.data.optional.idPedido).get().then(function(doc) {
									const data = doc.data()
									here.paymentInfo.ns = data.NS.type + '.' + data.NS.c_day.toString() + '.' + data.NS.c_general.toString() + '.' + data.NS.date.toString()
								})
							}
					  })
					  .catch(error => {
					    console.log("Error Flow: ", error)
					  })
				}
			}
    }
  }
</script>